import React from "react";
import moment from "moment/min/moment-with-locales";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { SplitButton } from "primereact/splitbutton";
import { withNamespaces } from "react-i18next";
import { ServiceLogin } from "../../service/Login";

import calendar from "../../images/Icons/calendar.svg";
import hospital from "../../images/Icons/lucide_hospital.svg";
import doctor from "../../images/Icons/hugeicons_doctor.svg";
import downloadImg from "../../images/Icons/Download-image.svg";
import downloadDicomZip from "../../images/Icons/Icone-DicomZip.svg";
import keyImg from "../../images/Icons/key.svg";
import share from "../../images/Icons/Share-icon.svg";
import printIcon from "../../images/Icons/Print-icon.svg";
import iconeProntuario from "../../images/Icons/iconeProntuario.svg";
import iconeAmpulheta from "../../images/Icons/icone-ampulheta.svg";
import iconeCorreto from "../../images/Icons/icone-correto.svg";

import viewerIcon_principal from "../../images/Icons/icone-viewer-branco.svg";
import galeryIcon_principal from "../../images/Icons/image_dashboard_white.svg";
import viewerIcon_secundario from "../../images/Icons/icone-viewer-azul.svg";
import galeryIcon_secundario from "../../images/Icons/mage_dashboard.svg";

import "./StudyCard.css";

const StudyCard = ({ pedido, parent, t }) => {
    const labelOrTranslation = (label, key, defaultLabels = []) => {
        const normalizedLabel = (label || "").trim().toLowerCase();
        const isDefaultLabel = defaultLabels.some(defaultLabel => defaultLabel.toLowerCase() === normalizedLabel);

        return label && !isDefaultLabel ? label : t(key);
    };

    const defaultLabels = {
        openViewer: ["Abrir Viewer", "Abrir visualizador", "Open Viewer", "WebViewer", "Web Viewer"],
        imageGallery: ["Galeria", "Galeria de imagens", "Galeria de Imagens", "Abrir Galeria", "Abrir galeria", "Abrir galeria de imagens", "Abrir Galeria de Imagens", "Image gallery", "Image Gallery", "Open gallery", "Open Gallery", "Open image gallery", "Gallery", "Galería", "Galería de imágenes", "Galería de Imágenes", "Abrir galería", "Abrir galería de imágenes"],
        downloadViewer: ["Baixar visualizador", "Baixar com visualizador", "Download viewer", "Download with viewer", "Descargar visualizador", "Descargar con visualizador"],
        downloadDicomZip: ["Baixar DICOM.zip", "Baixar DICOM zip", "Download DICOM.zip", "Download DICOM zip", "DOWLOAD DICOM.ZIP", "DOWLOAD DICOM.zip", "Descargar DICOM.zip", "Descargar DICOM zip"],
        report: ["Laudo"],
        printReport: ["Imprimir Laudo"],
        share: ["Compartilhar"],
        attachments: ["Anexos"],
        medicalOpinion: ["Parecer médico", "Parecer Médico", "Visualizar Parecer", "Visualizar Parecer Médico"],
        date: ["Data", "Data:"],
        unit: ["Unidade", "Unidade:"],
        requestingDoctor: ["Médico Solicitante"],
        performingDoctor: ["Médico Executante"],
        reviewingDoctor: ["Médico Revisor"],
        processing: ["Em processamento"],
        waitingReport: ["Aguardando laudo"],
        releasedReport: ["Laudo liberado"]
    };

    let dataEstudo = "";
    let btnLaudoDisabled = false;
    let btnImageDisable = false;
    let btnGaleriaDisable = false;
    let btnAnexoDisabled = false;
    let msgLaudo = "";
    let btnLaudoDisabledSemServico = false;
    let btnImagemDisabledSemServico = false;
    let titleBtnLaudoDisabledSemServico = "";
    let titleBtnImageDisabledSemServico = "";
    let temStl = pedido.temStl;

    try {
        dataEstudo = new Date(pedido.DataEstudo);
        dataEstudo = moment(dataEstudo).format("DD/MM/YYYY");
        btnAnexoDisabled = parent.DesabilitarBtnAnexo(pedido);
        btnLaudoDisabledSemServico = parent.DesabilitarBtnLaudoSemServico(pedido);
        btnLaudoDisabled = parent.state.isMedico & btnLaudoDisabledSemServico ? btnLaudoDisabledSemServico : parent.DesabilitarBtnLaudo(pedido);
        btnImagemDisabledSemServico = parent.DesabilitarBtnImagemSemServico(pedido);
        btnImageDisable = parent.state.btnImageDisable;
        msgLaudo = parent.msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImagemDisabledSemServico);
        titleBtnLaudoDisabledSemServico = parent.state.isMedico & btnLaudoDisabledSemServico ? t("PORTAL.CARD.ORDER_WITHOUT_SERVICE") : "";
        titleBtnImageDisabledSemServico = parent.state.isMedico & btnImagemDisabledSemServico ? t("PORTAL.CARD.ORDER_WITHOUT_SERVICE") : "";

        if (pedido.StudyUid != null && pedido.StudyUid !== "" || pedido.possuiJob !== false) {
            btnImageDisable = false;
        } else {
            btnImageDisable = true;
        }

        if (pedido.possuiJob !== false || pedido.StudyUid != null && pedido.StudyUid !== "") {
            btnGaleriaDisable = false;
        } else {
            btnGaleriaDisable = true;
        }
    } catch (ex) {
        console.log(ex);
    }

    const {
        isMedico,
        isExecutante,
        acaoPrincipalBotaoImagensMedico,
        acaoPrincipalBotaoImagensPaciente,
        acaoPrincipalThumbnailImagensMedico,
        acaoPrincipalThumbnailImagensPaciente
    } = parent.state;

    const isPerfilMedico = isMedico || isExecutante;

    const acaoPrincipal = isPerfilMedico
        ? acaoPrincipalBotaoImagensMedico
        : acaoPrincipalBotaoImagensPaciente;

    const acaoPrincipalPreview = isPerfilMedico
        ? acaoPrincipalThumbnailImagensMedico
        : acaoPrincipalThumbnailImagensPaciente;

    const labelAcaoPrincipal =
        acaoPrincipal === "Viewer"
            ? labelOrTranslation(parent.state.labelBotaoViewer, "PORTAL.CARD.OPEN_VIEWER", defaultLabels.openViewer)
            : labelOrTranslation(parent.state.labelBotaoGaleria, "PORTAL.CARD.IMAGE_GALLERY", defaultLabels.imageGallery);

    const acaoSecundaria = acaoPrincipal === "Viewer" ? "Galeria" : "Viewer";

    const iconPrincipal =
        acaoPrincipal === "Viewer"
            ? <img className="btnPrincipalImagens" src={viewerIcon_principal} alt={t("PORTAL.CARD.OPEN_VIEWER")} style={{ width: "30px", height: "30px", marginRight: "8px" }} />
            : <img className="btnPrincipalImagens" src={galeryIcon_principal} alt={t("PORTAL.CARD.IMAGE_GALLERY")} style={{ width: "30px", height: "30px", marginRight: "8px" }} />;

    const iconSecundario =
        acaoSecundaria === "Viewer"
            ? <img src={viewerIcon_secundario} alt={t("PORTAL.CARD.OPEN_VIEWER")} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
            : <img src={galeryIcon_secundario} alt={t("PORTAL.CARD.IMAGE_GALLERY")} style={{ width: "20px", height: "20px", marginRight: "8px" }} />;

    const mostrarBotaoImagens = isPerfilMedico
        ? (parent.state.botaoViewerAtivoMedico || parent.state.botaoGaleriaAtivoMedico)
        : (parent.state.botaoViewerAtivoPaciente || parent.state.botaoGaleriaAtivoPaciente);

    const hasOptions = (() => {
        if (isPerfilMedico) {
            const {
                botaoGaleriaAtivoMedico,
                botaoViewerAtivoMedico,
                acaoBaixarImagens_visualizador_Medico,
                acaoBaixarImagens_dicomZip_Medico
            } = parent.state;

            const variasOpcoesDeImagem = botaoGaleriaAtivoMedico && botaoViewerAtivoMedico;
            const opcoesDeDownload = acaoBaixarImagens_visualizador_Medico || acaoBaixarImagens_dicomZip_Medico;

            return variasOpcoesDeImagem || opcoesDeDownload;
        }

        const {
            botaoGaleriaAtivoPaciente,
            botaoViewerAtivoPaciente,
            acaoBaixarImagens_visualizador_Paciente,
            acaoBaixarImagens_dicomZip_Paciente
        } = parent.state;

        const variasOpcoesDeImagem = botaoGaleriaAtivoPaciente && botaoViewerAtivoPaciente;
        const opcoesDeDownload = acaoBaixarImagens_visualizador_Paciente || acaoBaixarImagens_dicomZip_Paciente;

        return variasOpcoesDeImagem || opcoesDeDownload;
    })();

    const hasLaudoExtras = isPerfilMedico
        ? (parent.state.botaoImprimirLaudoAtivoMedico || parent.state.botaoCompartilharAtivoMedico)
        : (parent.state.botaoImprimirLaudoAtivoPaciente || parent.state.botaoCompartilharAtivoPaciente);

    const perfil = parent.RetPerfil();
    const isConvenioPerfil = perfil === "Convênio";
    const isSharedProfile = parent.state.isAcessoCompartilhado;

    const renderStatusMedico = () => (
        <>
            <div className="statusArea-yellow" style={{ display: (btnLaudoDisabled && btnImageDisable) ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {labelOrTranslation(parent.state.labelStatusProcessamentoMedico, "SCREENS.CONFIG.PROCESSING", defaultLabels.processing)} </b>
                </div>
            </div>

            <div className="statusArea-yellow" style={{ display: (btnLaudoDisabled && !btnImageDisable) ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {labelOrTranslation(parent.state.labelStatusAguardandoMedico, "SCREENS.CONFIG.WAITING_REPORT", defaultLabels.waitingReport)} </b>
                </div>
            </div>

            <div className="statusArea-green" style={{ display: !btnLaudoDisabled ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeCorreto} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {labelOrTranslation(parent.state.labelStatusLiberadoMedico, "SCREENS.CONFIG.RELEASED_REPORT", defaultLabels.releasedReport)} </b>
                </div>
            </div>
        </>
    );

    const renderStatusPaciente = () => (
        <>
            <div className="statusArea-yellow" style={{ display: (btnLaudoDisabled && btnImageDisable) ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {labelOrTranslation(parent.state.labelStatusProcessamentoPaciente, "SCREENS.CONFIG.PROCESSING", defaultLabels.processing)} </b>
                </div>
            </div>

            <div className="statusArea-yellow" style={{ display: (btnLaudoDisabled && !btnImageDisable) ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {labelOrTranslation(parent.state.labelStatusAguardandoPaciente, "SCREENS.CONFIG.WAITING_REPORT", defaultLabels.waitingReport)} </b>
                </div>
            </div>

            <div className="statusArea-green" style={{ display: !btnLaudoDisabled ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeCorreto} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {labelOrTranslation(parent.state.labelStatusLiberadoPaciente, "SCREENS.CONFIG.RELEASED_REPORT", defaultLabels.releasedReport)} </b>
                </div>
            </div>
        </>
    );

    const renderMedicoOuConvenioProfile = () => (
        <>
            <div className="card-details">
                <div className="PacienteDados">
                    <div className="PacienteDados-Nome-Prontuario-status-desktop">
                        <div className="PacienteDados-Nome">
                            <b>{pedido.Paciente.Nome}</b>
                        </div>

                        {(parent.state.infoProntuarioAtivoMedico) && (
                            <div style={{ display: "flex" }}>
                                <div className="PacienteDados-icone">
                                    <b> | </b>
                                    <img src={iconeProntuario} alt={t("SCREENS.CONFIG.MEDICAL_RECORD")} style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                </div>

                                <div className="PacienteDados-Prontuario">
                                    <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                </div>
                            </div>
                        )}

                        {(parent.state.statusAtivoMedico) && (<div>{renderStatusMedico()}</div>)}
                    </div>

                    <div className="PacienteDados-celular">
                        <div className="PacienteDados-Nome-Prontuario">
                            {!parent.state.isAcessoCompartilhado && (
                                <div className="PacienteDados-Nome">
                                    <b>{pedido.Paciente.Nome}</b>
                                </div>
                            )}

                            {(parent.state.infoProntuarioAtivoMedico) && (
                                <div style={{ display: "flex" }}>
                                    <div className="PacienteDados-icone">
                                        <b> | </b>
                                        <img src={iconeProntuario} alt={t("SCREENS.CONFIG.MEDICAL_RECORD")} style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                    </div>

                                    {!parent.state.isAcessoCompartilhado && (
                                        <div className="PacienteDados-Prontuario">
                                            <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="PacienteDados-Exame-Status">
                            <div className={"ExameTituloMedico"}>
                                <b>
                                    {pedido.Procedimento.Modalidade.Abreviacao} - {" "}
                                    {pedido.Procedimento.Nome}
                                </b>
                            </div>

                            {(parent.state.statusAtivoMedico) && (
                                <div>{renderStatusMedico()}</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-details">
                <div className="card-details-zone">
                    <div className="card-details-left">
                        <div className="PacienteDados-Nome-Prontuario-status-tablet">
                            <div className="PacienteDados-Nome">
                                <b>{pedido.Paciente.Nome}</b>
                            </div>

                            {(parent.state.infoProntuarioAtivoMedico) && (
                                <div className="PacienteDados-icone-prontuario" style={{ display: "flex" }}>
                                    <div className="PacienteDados-icone">
                                        <b> | </b>
                                    </div>

                                    <div className="PacienteDados-Prontuario">
                                        <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                    </div>
                                </div>
                            )}

                            {(parent.state.statusAtivoMedico) && (
                                <div className="statusArea-medico">{renderStatusMedico()}</div>
                            )}
                        </div>

                        <div className="PacienteDados-Exame-Data-Acnumber-Desktop">
                            <div className={"ExameTituloMedico-desktop"}>
                                <b>
                                    {pedido.Procedimento.Modalidade.Abreviacao} -{" "}
                                    {pedido.Procedimento.Nome}
                                </b>
                            </div>

                            {(parent.state.infoDataAtivoMedico) && (
                                <div className="DataExameMedico">
                                    <img src={calendar} style={{ width: "20px", height: "20px" }} />
                                    <div>
                                        {labelOrTranslation(parent.state.labelInfoData, "PORTAL.CARD.DATE", defaultLabels.date)} <b>{dataEstudo}</b>
                                    </div>
                                </div>
                            )}

                            {(parent.state.infoAcNumberAtivoMedico) && pedido.AcNumber && pedido.AcNumber.trim() !== "" && (
                                <div className="AcNumber">
                                    <img src={keyImg} style={{ marginRight: "5px", maxWidth: "18px" }} />
                                    {parent.state.labelInfoAcNumber || "Ac. Number"}  <b>{pedido.AcNumber}</b>
                                </div>
                            )}
                        </div>

                        <div className="PacienteDados-Data-Acnumber">
                            {(parent.state.infoDataAtivoMedico) && (
                                <div className="DataExameMedico">
                                    <img src={calendar} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                    {labelOrTranslation(parent.state.labelInfoData, "PORTAL.CARD.DATE", defaultLabels.date)} <b>{" " + dataEstudo}</b>
                                </div>
                            )}

                            {(parent.state.infoAcNumberAtivoMedico) && pedido.AcNumber && pedido.AcNumber.trim() !== "" && (
                                <div className="AcNumber">
                                    <img src={keyImg} style={{ marginRight: "5px", maxWidth: "18px" }} />
                                    {parent.state.labelInfoAcNumber || "Ac. Number"}  <b>{pedido.AcNumber}</b>
                                </div>
                            )}
                        </div>

                        <div className="PacienteDados-Info">
                            <br></br>
                            {(parent.state.infoUnidadeAtivoMedico) && (
                                <div className="Unidade">
                                    <img src={hospital} style={{ marginRight: "5px" }} />
                                    {labelOrTranslation(parent.state.labelInfoUnidade, "PORTAL.CARD.UNIT", defaultLabels.unit)}  <b>{pedido.Unidade.Nome}</b>
                                </div>
                            )}

                            {parent.state.infoMedSolicitanteAtivoMedico && pedido.MedicoSolicitante?.Nome && pedido.MedicoSolicitante.Nome.trim() !== "" && (
                                <div className="MedicoSolicitante">
                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                    {labelOrTranslation(parent.state.labelInfoMedSolicitante, "PORTAL.CARD.REQUESTING_DOCTOR", defaultLabels.requestingDoctor)} <b>{pedido.MedicoSolicitante.Nome}</b>
                                </div>
                            )}

                            {(parent.state.infoMedExecutanteAtivoMedico) && pedido.MedicoExecutante?.Nome && pedido.MedicoExecutante.Nome.trim() !== "" && (
                                <div className="MedicoExecutante">
                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                    {labelOrTranslation(parent.state.labelInfoMedExecutante, "PORTAL.CARD.PERFORMING_DOCTOR", defaultLabels.performingDoctor)}  <b>{pedido.MedicoExecutante.Nome}</b>
                                </div>
                            )}

                            {(parent.state.infoMedRevisorAtivoMedico) && pedido.MedicoRevisor?.Nome && pedido.MedicoRevisor.Nome.trim() !== "" && (
                                <div className="MedicoRevisor">
                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                    {labelOrTranslation(parent.state.labelInfoMedRevisor, "PORTAL.CARD.REVIEWING_DOCTOR", defaultLabels.reviewingDoctor)}  <b>{pedido.MedicoRevisor.Nome}</b>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const renderPacienteBase = (mostrarNomePaciente) => (
        <>
            <div className={"ExameTitulo"}>
                {mostrarNomePaciente && (
                    <div className="PacienteDados-Nome" style={{ fontSize: "20px", marginBottom: "10px" }}>
                        <b>{pedido.Paciente.Nome}</b>
                    </div>
                )}

                <div className={"PacienteProcedimentoStatusDados"} style={{ display: "flex" }}>
                    <div className={"PacienteProcedimentoDados"}>
                        <div style={{ display: "flex" }}>
                            <b className={"PacienteProcedimentoTitulo"}>
                                {pedido.Procedimento.Modalidade.Abreviacao} -{" "}
                                {pedido.Procedimento.Nome}
                            </b>

                            {(parent.state.infoProntuarioAtivoPaciente) && (
                                <div className="PacienteDados-icone-prontuario" style={{ display: "flex" }}>
                                    <div className="PacienteDados-icone">
                                        <b> | </b>
                                        <img src={iconeProntuario} alt={t("SCREENS.CONFIG.MEDICAL_RECORD")} style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                    </div>

                                    <div className="PacienteDados-Prontuario">
                                        <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {(parent.state.statusAtivoPaciente) && (
                        <div className={"PacienteProcedimentoStatus"}>
                            {renderStatusPaciente()}
                        </div>
                    )}

                    {(parent.state.infoDataAtivoPaciente) && (
                        <div className="DataExame-mobile">
                            <img src={calendar} style={{ marginRight: "5px" }} /> {labelOrTranslation(parent.state.labelInfoData, "PORTAL.CARD.DATE", defaultLabels.date)} <b>{dataEstudo}</b>
                        </div>
                    )}
                </div>
            </div>

            <div className="StudyArea-info-5">
                <div className="StudyArea-info-6">
                    {(parent.state.infoDataAtivoPaciente) && (
                        <div className="DataExame">
                            <img src={calendar} style={{ marginRight: "5px" }} /> {labelOrTranslation(parent.state.labelInfoData, "PORTAL.CARD.DATE", defaultLabels.date)} <b>{dataEstudo}</b>
                        </div>
                    )}

                    {(parent.state.infoUnidadeAtivoPaciente) && (
                        <div className="Unidade">
                            <img src={hospital} style={{ marginRight: "5px" }} />
                            {labelOrTranslation(parent.state.labelInfoUnidade, "PORTAL.CARD.UNIT", defaultLabels.unit)} <b>{pedido.Unidade.Nome}</b>
                        </div>
                    )}

                    {(parent.state.infoAcNumberAtivoPaciente) && pedido.AcNumber && pedido.AcNumber.trim() !== "" && (
                        <div className="AcNumber">
                            <img src={keyImg} style={{ width: "18px", height: "18px", marginRight: "5px" }} />
                            {parent.state.labelInfoAcNumber || "Ac.Number"} <b>{pedido.AcNumber}</b>
                        </div>
                    )}
                </div>

                <div><br></br></div>

                <div className="PacienteDados-Info">
                    {(parent.state.infoMedSolicitanteAtivoPaciente) && pedido.MedicoSolicitante?.Nome && pedido.MedicoSolicitante.Nome.trim() !== "" && (
                        <div className="MedicoSolicitante">
                            <img src={doctor} style={{ marginRight: "5px" }} />
                            {labelOrTranslation(parent.state.labelInfoMedSolicitante, "PORTAL.CARD.REQUESTING_DOCTOR", defaultLabels.requestingDoctor)} <b>{pedido.MedicoSolicitante.Nome}</b>
                        </div>
                    )}

                    {(parent.state.infoMedExecutanteAtivoPaciente) && pedido.MedicoExecutante?.Nome && pedido.MedicoExecutante.Nome.trim() !== "" && (
                        <div className="MedicoExecutante">
                            <img src={doctor} style={{ marginRight: "5px" }} />
                            {labelOrTranslation(parent.state.labelInfoMedExecutante, "PORTAL.CARD.PERFORMING_DOCTOR", defaultLabels.performingDoctor)} <b>{pedido.MedicoExecutante.Nome}</b>
                        </div>
                    )}

                    {(parent.state.infoMedRevisorAtivoPaciente) && pedido.MedicoRevisor?.Nome && pedido.MedicoRevisor.Nome.trim() !== "" && (
                        <div className="MedicoRevisor">
                            <img src={doctor} style={{ marginRight: "5px" }} />
                            {labelOrTranslation(parent.state.labelInfoMedRevisor, "PORTAL.CARD.REVIEWING_DOCTOR", defaultLabels.reviewingDoctor)} <b>{pedido.MedicoRevisor.Nome}</b>
                        </div>
                    )}
                </div>
            </div>
        </>
    );

    const renderPacienteProfile = () => renderPacienteBase(false);
    const renderAcessoCompartilhadoProfile = () => renderPacienteBase(true);
    const renderMedicoProfile = () => renderMedicoOuConvenioProfile();
    const renderConvenioProfile = () => renderMedicoOuConvenioProfile();

    const renderVeterinarioProfile = () => {
        if (!pedido?.Unidade?.Veterinaria) {
            return null;
        }

        return (
            <div>
                <div className="Campos-veterinario">
                    <div className="Tutor">
                        {t("PORTAL.CARD.TUTOR")} <b>{pedido.Tutor}</b>
                    </div>
                    <div className="Raca">
                        {t("PORTAL.CARD.BREED")} <b>{pedido.Raca}</b>
                    </div>
                    <div className="Especie">
                        {t("PORTAL.CARD.SPECIES")} <b>{pedido.Especie}</b>
                    </div>
                </div>
            </div>
        );
    };

    const renderProfileContent = () => {
        if (isPerfilMedico) {
            return renderMedicoProfile();
        }

        if (isConvenioPerfil) {
            return renderConvenioProfile();
        }

        if (isSharedProfile) {
            return renderAcessoCompartilhadoProfile();
        }

        return renderPacienteProfile();
    };

    return (
        <div className="render-list-item-root">
            <div className="StudyArea">
                <div className="StudyArea-Left" style={{ display: "flex" }}>
                    <div>
                        <div style={{ display: "flex" }}>
                            <div className="StudyArea-info">
                                <div style={{ padding: "10px" }}>
                                    {renderProfileContent()}
                                    {renderVeterinarioProfile()}
                                </div>
                            </div>
                        </div>

                        <div className="StudyArea-Buttons">
                            <div className="BtnImagens-area" style={{ display: btnImageDisable ? "none" : "block" }}>
                                {mostrarBotaoImagens && (
                                    <div className="BtnImagens-area" style={{ display: btnImageDisable ? "none" : "block" }}>
                                        {hasOptions && (pedido.StudyUid) ? (
                                            <SplitButton
                                                className="BtnImagens"
                                                icon={iconPrincipal}
                                                label={labelAcaoPrincipal}
                                                iconpos="right"
                                                appendTo="self"
                                                onClick={() => parent.handleAbrirModalGenerica(pedido, acaoPrincipal)}
                                                disabled={btnImageDisable}
                                                tooltipOptions={{ position: "bottom" }}
                                                model={[
                                                    {
                                                        label: acaoSecundaria === "Galeria"
                                                            ? labelOrTranslation(parent.state.labelBotaoGaleria, "PORTAL.CARD.IMAGE_GALLERY", defaultLabels.imageGallery)
                                                            : labelOrTranslation(parent.state.labelBotaoViewer, "PORTAL.CARD.OPEN_VIEWER", defaultLabels.openViewer),
                                                        icon: iconSecundario,
                                                        disabled: btnGaleriaDisable,
                                                        visible: (acaoSecundaria === "Viewer" && !pedido.StudyUid) ? false : isPerfilMedico
                                                            ? (parent.state.botaoGaleriaAtivoMedico && parent.state.botaoViewerAtivoMedico)
                                                            : (parent.state.botaoGaleriaAtivoPaciente && parent.state.botaoViewerAtivoPaciente),
                                                        command: () => parent.handleAbrirModalGenerica(pedido, acaoSecundaria)
                                                    },
                                                    {
                                                        label: labelOrTranslation(parent.state.lblbtnDownloadVisualizador, "PORTAL.CARD.DOWNLOAD_VIEWER", defaultLabels.downloadViewer),
                                                        icon: <img src={downloadImg} alt={t("PORTAL.CARD.DOWNLOAD_VIEWER")} style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                        visible: pedido.StudyUid ? isPerfilMedico
                                                            ? parent.state.acaoBaixarImagens_visualizador_Medico
                                                            : parent.state.acaoBaixarImagens_visualizador_Paciente
                                                            : false,
                                                        command: () => parent.handleBaixarImagem(pedido)
                                                    },
                                                    {
                                                        label: labelOrTranslation(parent.state.lblbtnDownloadDicomZip, "PORTAL.CARD.DOWNLOAD_DICOM_ZIP", defaultLabels.downloadDicomZip),
                                                        icon: <img src={downloadDicomZip} alt={t("PORTAL.CARD.DOWNLOAD_DICOM_ZIP")} style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                        visible: pedido.StudyUid ? isPerfilMedico
                                                            ? parent.state.acaoBaixarImagens_dicomZip_Medico
                                                            : parent.state.acaoBaixarImagens_dicomZip_Paciente
                                                            : false,
                                                        command: () => parent.handleBaixarDicomZip(pedido)
                                                    }
                                                ]}
                                                title={titleBtnImageDisabledSemServico}
                                            />
                                        ) : (
                                            <Button
                                                className="BtnImagens"
                                                icon={iconPrincipal}
                                                label={labelAcaoPrincipal}
                                                iconPos="right"
                                                onClick={() => parent.handleAbrirModalGenerica(pedido, acaoPrincipal)}
                                                disabled={btnImageDisable}
                                                tooltipOptions={{ position: "bottom" }}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>

                            <div>
                                <div style={{ display: btnLaudoDisabled ? "none" : "block" }}>
                                    {(isPerfilMedico ? parent.state.botaoLaudoAtivoMedico : parent.state.botaoLaudoAtivoPaciente) ? (
                                        hasLaudoExtras ? (
                                            <SplitButton
                                                className="BtnLaudo"
                                                icon="custom-icon"
                                                label={labelOrTranslation(parent.state.labelBotaoLaudo, "PORTAL.CARD.REPORT", defaultLabels.report)}
                                                iconpos="right"
                                                appendTo="self"
                                                onClick={() => parent.handleAbrirModalGenerica(pedido, "Laudo")}
                                                disabled={btnLaudoDisabled}
                                                tooltipOptions={{ position: "bottom" }}
                                                title={titleBtnLaudoDisabledSemServico}
                                                model={[
                                                    {
                                                        label: labelOrTranslation(parent.state.labelBotaoImprimirLaudo, "PORTAL.CARD.PRINT_REPORT", defaultLabels.printReport),
                                                        icon: <img src={printIcon} alt={t("PORTAL.CARD.PRINT_REPORT")} style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                        disabled: btnLaudoDisabled,
                                                        visible: isPerfilMedico
                                                            ? parent.state.botaoImprimirLaudoAtivoMedico
                                                            : parent.state.botaoImprimirLaudoAtivoPaciente,
                                                        command: () => parent.handleImprimirLaudo(pedido)
                                                    },
                                                    ...(pedido.CompartilharPortal && parent.state.isAcessoCompartilhado === false
                                                        ? [{
                                                            label: labelOrTranslation(parent.state.labelBotaoCompartilhar, "PORTAL.BUTTON.SHARE", defaultLabels.share),
                                                            icon: <img src={share} alt={t("PORTAL.BUTTON.SHARE")} style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                            disabled: btnLaudoDisabled,
                                                            visible: isPerfilMedico
                                                                ? parent.state.botaoCompartilharAtivoMedico
                                                                : parent.state.botaoCompartilharAtivoPaciente,
                                                            command: () => parent.handleAbrirModalGenerica(pedido, "Compartilhar")
                                                        }]
                                                        : [])
                                                ]}
                                            />
                                        ) : (
                                            <Button
                                                className="BtnLaudo"
                                                icon="custom-icon"
                                                label={labelOrTranslation(parent.state.labelBotaoLaudo, "PORTAL.CARD.REPORT", defaultLabels.report)}
                                                iconpos="right"
                                                onClick={() => parent.handleAbrirModalGenerica(pedido, "Laudo")}
                                                disabled={btnLaudoDisabled}
                                                tooltipOptions={{ position: "bottom" }}
                                                title={titleBtnLaudoDisabledSemServico}
                                            />
                                        )
                                    ) : null}
                                </div>
                            </div>

                            <div>
                                {(isPerfilMedico ? parent.state.botaoAnexosAtivoMedico : parent.state.botaoAnexosAtivoPaciente) && (
                                    <Button
                                        visible={!btnAnexoDisabled}
                                        className="btnAnexos"
                                        type="text"
                                        tooltipOptions={{ position: "bottom" }}
                                        icon="custom-icon"
                                        tooltip={t("PORTAL.CARD.ATTACHMENTS")}
                                        iconpos="right"
                                        label={labelOrTranslation(parent.state.labelBotaoAnexos, "PORTAL.CARD.ATTACHMENTS", defaultLabels.attachments)}
                                        onClick={() => parent.handleAbrirModalGenerica(pedido, "Anexos")}
                                    />
                                )}
                            </div>

                            <div style={{ display: ServiceLogin.getNaoPodeVisualizarComentarios() || btnImageDisable ? "none" : "block" }}>
                                {isPerfilMedico && parent.state.botaoParecerAtivoMedico && (
                                    <Button
                                        type="text"
                                        tooltipOptions={{ position: "bottom" }}
                                        tooltip={t("PORTAL.CARD.MEDICAL_OPINION")}
                                        icon="custom-icon"
                                        iconpos="right"
                                        label={labelOrTranslation(parent.state.labelBotaoParecer, "PORTAL.CARD.MEDICAL_OPINION", defaultLabels.medicalOpinion)}
                                        className="btnParecerMedico"
                                        onClick={() => parent.handleAbrirModalGenerica(pedido, "Parecer")}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="StudyArea-Preview">
                        <div className="StudyPreview-tablet">
                            {pedido.imagemPreviewUrl ? (
                                <div className="StudyPreview-Image">
                                    <img
                                        src={pedido.imagemPreviewUrl}
                                        alt={t("PORTAL.CARD.PREVIEW_ALT")}
                                        onClick={() => parent.handleAbrirModalGenerica(pedido, acaoPrincipalPreview)}
                                        onLoad={(e) => e.target.style.opacity = 1}
                                        style={{
                                            width: "150px",
                                            height: "160px",
                                            borderRadius: "15px",
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            opacity: 0,
                                            transition: "opacity 0.3s ease-in-out"
                                        }}
                                    />

                                    <div className="spinner-imagePrevew">
                                        <div className="spinner-preview" />
                                    </div>
                                </div>
                            ) : pedido.imagemPreviewUrl === undefined ? (
                                <div className="StudyPreview-Image">
                                    <div className="spinner-imagePrevew">
                                        <div className="spinner-preview" />
                                    </div>
                                </div>
                            ) : (
                                <div className="StudyPreview-ImgNotFound">
                                    <div className="StudyPreview-ImgNotFound-Img"> </div>
                                    <div className="StudyPreview-ImgNotFound-Txt">
                                        <p> {t("PORTAL.CARD.IMAGES_NOT_AVAILABLE_LINE_1")} </p>
                                        <p> {t("PORTAL.CARD.IMAGES_NOT_AVAILABLE_LINE_2")} </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="StudyArea-Right">
                    <div className="StudyPreview">
                        {pedido.imagemPreviewUrl ? (
                            <div className="StudyPreview-Image">
                                <img
                                    src={pedido.imagemPreviewUrl}
                                    alt={t("PORTAL.CARD.PREVIEW_ALT")}
                                    onClick={() => parent.handleAbrirModalGenerica(pedido, acaoPrincipalPreview)}
                                    onLoad={(e) => e.target.style.opacity = 1}
                                    style={{
                                        width: "223px",
                                        height: "232px",
                                        borderRadius: "15px",
                                        cursor: "pointer",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        opacity: 0,
                                        transition: "opacity 0.3s ease-in-out"
                                    }}
                                />

                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        ) : pedido.imagemPreviewUrl === undefined ? (
                            <div className="StudyPreview-Image">
                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        ) : (
                            <div className="StudyPreview-ImgNotFound">
                                <div className="StudyPreview-ImgNotFound-Img"> </div>
                                <div className="StudyPreview-ImgNotFound-Txt">
                                    <p> {t("PORTAL.CARD.IMAGES_NOT_AVAILABLE_LINE_1")} </p>
                                    <p> {t("PORTAL.CARD.IMAGES_NOT_AVAILABLE_LINE_2")} </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Panel
                id={`panelLaudo-${pedido.Id}`}
                className={parent.state.panelVisible ? "p-col-8" : ""}
                style={{
                    visibility: parent.mobilecheck() || parent.state.panelVisible === false || parent.state.selectedPedido.Id !== pedido.Id ? "hidden" : "visible"
                }}
                header={<div>
                    <div>{pedido.Paciente.Nome}</div>
                    <div>
                        <Button
                            icon="pi pi-window-maximize"
                            onClick={e => parent.viewFullScreen(`panelLaudo-${pedido.Id}`)}
                            style={{
                                position: "absolute",
                                float: "right",
                                right: parent.state.isFullScreen ? "50px" : "82px",
                                marginTop: "-25px"
                            }}
                        />
                    </div>

                    <div>
                        <Button
                            icon="pi pi-times"
                            onClick={() => parent.closeModalFullScreen(`panelLaudo-${pedido.Id}`)}
                            style={{
                                position: "absolute",
                                float: "right",
                                right: parent.state.isFullScreen ? "7px" : "40px",
                                marginTop: "-25px"
                            }}
                        />
                    </div>
                </div>}
            >
                <div id={`divLaudo-${pedido.Id}`} style={{ height: parent.state.panelVisible ? "65vh" : "1px" }}></div>
            </Panel>
        </div>
    );
};

export default withNamespaces()(StudyCard);
